import _ from 'lodash';
import { wardMenuE } from './userRole';

const P = {
  hospitalId: 'hospitalId',
  wards: 'wards',
  wardId: 'wardId',
  hospitalName: 'hospitalName',
  wardName: 'wardName',
  ipasMapping: 'ipasMapping',
  hospCode: 'hospCode',
  hospId: 'hospId',
};

const hospitalWardListFunc = {
  getHospitalUseId: function (allData, hospitalId) {
    return _.find(allData, (item) => {
      return item?.[P.hospitalId] === hospitalId;
    });
  },

  isHospWardExist: function (allData, hospitalId, wardId) {
    const hospital = this.getHospitalUseId(allData, hospitalId);
    return hospital ? Boolean(hospitalFunc.getWard(hospital, wardId)) : false;
  },

  isWardExist: function (allData, wardId) {
    return this.getAllWardId(allData)?.includes(wardId);
  },

  getDetailFormat: function (allData, hospitalId, wardId, hospCode) {
    const hospWard = this.getHospitalUseId(allData, hospitalId, wardId);
    const detail = hospitalFunc.getDetailFormat(hospWard, wardId);
    return {
      ...detail,
      [P.hospId]: hospitalId,
      [P.wardId]: wardId,
      [P.hospCode]: hospCode,
    };
  },

  getHospitalAllWardUseId: function (allData, hospitalId) {
    const hosp = this.getHospitalUseId(allData, hospitalId);
    return hosp ? hosp[P.wards] : null;
  },
  getHospitalUseIndex: function (allData, hospitalIndex) {
    return Array.isArray(allData) ? allData[hospitalIndex] : null;
  },

  getAllHospitalSelectFormat: function (allData) {
    return _.map(allData, (item) => {
      return { text: item[P.hospitalName], value: item[P.hospitalId] };
    });
  },

  getHospitalAllWardUseIdSelectFormat: function (allData, hospitalId) {
    const hospitalAllWard = this.getHospitalAllWardUseId(allData, hospitalId);
    return _.map(hospitalAllWard, (item) => {
      return { text: item.wardName, value: item.wardId };
    });
  },

  getHospitalWardUseId: function (allData, hospitalId, wardId) {
    const hospitalObj = this.getHospitalUseId(allData, hospitalId);
    return _.filter(hospitalObj?.wards, (item) => {
      return item[P.wardId] === wardId;
    });
  },

  getHospitalAllWardUseIdFormat: function (allData, hospitalId) {
    const allWard = this.getHospitalAllWardUseId(allData, hospitalId);
    return _.map(allWard, (item) => {
      return { text: item.wardName, value: item.wardId };
    });
  },

  getAllWardId: function (allData) {
    const result = [];
    _.forEach(allData, (hospItem) => {
      _.forEach(hospItem?.[P.wards], (wardItem) => {
        result.push(wardItem.wardId);
      });
    });
    return result;
  },

  getAllWardFormat: function (allData) {
    const result = [];
    _.forEach(allData, (hospItem) => {
      _.forEach(hospItem?.[P.wards], (wardItem) => {
        result.push({ text: wardItem.wardName, value: wardItem.wardId });
      });
    });
    return _.sortBy(result, ['text']);
  },

  getHospitalAllWardUseIndex: function (allData, hospitalIndex) {
    const hospitalObj = this.getHospitalUseIndex(allData, hospitalIndex);
    return hospitalObj ? hospitalObj?.wards : null;
  },

  getHospitalAllWardUseIndexSelectFormat: function (allData, hospitalIndex) {
    const wards = this.getHospitalAllWardUseIndex(allData, hospitalIndex);
    return _.map(wards, (item) => {
      return { text: item[P.wardName], value: item[P.wardId] };
    });
  },

  writeFilterHospitalWard: function (allData, hospitalId, wardId) {
    if (!Array.isArray(hospitalId)) hospitalId = [hospitalId];
    const hosps = _.filter(allData, (item) => {
      return hospitalId.includes(item[P.hospitalId]);
    });
    if (!Array.isArray(wardId)) wardId = [wardId];
    return hosps.map((hospitalWard) => {
      return {
        ...hospitalWard,
        [P.wards]: _.filter(hospitalWard?.[P.wards], (item) => {
          return wardId.includes(item[P.wardId]);
        }),
      };
    });
  },

  getHospitalIndex: function (allData, hospitalId) {
    return _.findIndex(allData, (item) => {
      return item[P.hospitalId] === hospitalId;
    });
  },

  getWardIndex: function (allData, hospitalId, wardId) {
    const hospitalIndex = _.findIndex(allData, (item) => {
      return item[P.hospitalId] === hospitalId;
    });
    return hospitalIndex > -1
      ? _.findIndex(allData?.[hospitalIndex], (item) => {
          return item[P.wardId] === wardId;
        })
      : hospitalIndex;
  },

  getIpasFirstHospitalCode: function (allData, hospitalId, wardId) {
    const hospital = this.getHospitalUseId(allData, hospitalId);
    return hospitalFunc.getIpasFirstHospitalCode(hospital, wardId);
  },

  getWardAndHospitalIndexObj: function (allData, hospitalId, wardId) {
    const hospitalIndex = _.findIndex(allData, (item) => {
      return item[P.hospitalId] === hospitalId;
    });
    const wardIndex =
      hospitalIndex > -1
        ? _.findIndex(allData?.[hospitalIndex]?.wards, (item) => {
            return item[P.wardId] === wardId;
          })
        : -1;
    return {
      hospital: hospitalIndex,
      ward: wardIndex,
    };
  },
};

const hospitalFunc = {
  getWards: (allData) => {
    return allData ? allData[P.wards] : null;
  },
  getWard: function (allData, wardId) {
    const wards = this.getWards(allData);
    return _.find(wards, (item) => {
      return item[P.wardId] === wardId;
    });
  },
  getWardMenus: function (allData, wardId) {
    const result = {};
    const ward = this.getWard(allData, wardId);
    if (!ward) {
      Object.keys(wardMenuE).forEach((item) => {
        result[item] = false;
      });
    } else {
      Object.keys(wardMenuE).forEach((item) => {
        result[item] = ward[item];
      });
    }
    return result;
  },

  getHospitalName: function (allData) {
    return allData ? allData[P.hospitalName] : null;
  },

  getWardName: function (allData, wardId) {
    const wardObj = this.getWard(allData, wardId);
    return wardObj ? wardObj[P.wardName] : null;
  },

  getHospCode: function (allData) {
    return allData ? allData[P.hospCode] : null;
  },

  getDetailFormat: function (allData, wardId) {
    return {
      [P.wardName]: this.getWardName(allData, wardId),
      [P.hospitalName]: this.getHospitalName(allData),
      [P.hospCode]: this.getHospCode(allData),
    };
  },

  getIpasFirstHospitalCode: function (alldata, wardId) {
    const wardObj = this.getWard(alldata, wardId);
    return wardObj?.[P.ipasMapping]?.[0]?.[P.hospCode];
  },
};

export { hospitalWardListFunc, hospitalFunc };
